import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import BottomNav from "../components/BottomNav";
import ContestCard from "../components/ContestCard";
import { getContests } from "../lib/api";
import { Tv, Zap, Swords } from "lucide-react";

const MODES = [
  { v: "island", l: "Island Challenge", icon: Tv, color: "#00F0FF", desc: "Survive 24-hour elimination waves. Lowest heat leaves." },
  { v: "road", l: "Road to Fame", icon: Zap, color: "#FFD600", desc: "Breakout creators only. Climb the ladder, earn crowns." },
  { v: "showdown", l: "Big Showdown", icon: Swords, color: "#FF0055", desc: "Head-to-head fandom war. Winner takes the glory." },
];

export default function RealityMode() {
  const [byMode, setByMode] = useState({ island: [], road: [], showdown: [] });

  useEffect(() => {
    (async () => {
      const out = {};
      for (const m of MODES) {
        out[m.v] = await getContests({ mode: m.v });
      }
      setByMode(out);
    })();
  }, []);

  return (
    <div className="min-h-screen pb-safe" data-testid="reality-page">
      <Header title="Reality Mode" />
      <div className="max-w-xl mx-auto px-4 pt-4 space-y-5">
        <div className="relative rounded-3xl overflow-hidden glass-strong">
          <img
            src="https://images.pexels.com/photos/18421576/pexels-photo-18421576.jpeg?auto=compress&cs=tinysrgb&w=1200"
            alt=""
            className="absolute inset-0 w-full h-full object-cover opacity-60"
          />
          <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, rgba(5,5,8,0.3), rgba(5,5,8,0.9))" }} />
          <div className="relative p-6">
            <p className="chip inline-flex" style={{ background: "#FF005522", color: "#FF0055", border: "1px solid #FF005555" }}>Limited Season</p>
            <h1 className="font-display text-4xl font-bold mt-2 tracking-tight">Reality Arena</h1>
            <p className="text-sm text-white/70 mt-1">Elimination-style contests with cinematic stakes. Non-cash rewards only.</p>
          </div>
        </div>

        {MODES.map((m) => (
          <section key={m.v} data-testid={`reality-mode-${m.v}`}>
            <div className="flex items-center gap-2 mb-2">
              <span className="w-9 h-9 rounded-xl grid place-items-center" style={{ background: `${m.color}22`, border: `1px solid ${m.color}55` }}>
                <m.icon className="w-4 h-4" style={{ color: m.color }} />
              </span>
              <div>
                <h2 className="font-display text-xl font-bold">{m.l}</h2>
                <p className="text-xs text-white/55">{m.desc}</p>
              </div>
            </div>
            {(byMode[m.v] || []).length === 0 ? (
              <div className="glass rounded-2xl p-4 text-sm text-white/50">No {m.l} contests right now.</div>
            ) : (
              <div className="space-y-3">
                {byMode[m.v].map((c) => <ContestCard key={c.contest_id} contest={c} />)}
              </div>
            )}
          </section>
        ))}

        <div className="h-10" />
      </div>
      <BottomNav />
    </div>
  );
}
